import http from "../axios/http-common";

class InterfaceKonsul {

  getKonsul(reg) {
    // return http.get(`/register/${reg}/surat-konsul`)
    return http.getData(`/register/${reg}/surat-konsul`)
  }
  getKonsulByID(id) {
    // return http.get(`/surat-konsul/${id}`)
    return http.getData(`/surat-konsul/${id}`)
  }
  saveKonsul(reg, cm, unit_pengirim_id, unit_tujuan_id, dr_pengirim_id, dr_tujuan_id, diag, masalah, konsultasi) {
    return http.postData(`/surat-konsul`, {
      register_id: reg,
      pasien_rm: cm,
      unit_pengirim_id: unit_pengirim_id,
      unit_tujuan_id: unit_tujuan_id,
      dr_pengirim_id: dr_pengirim_id,
      dr_tujuan_id: dr_tujuan_id,
      diagnosis: diag,
      masalah: masalah,
      konsultasi: konsultasi
    })
  }
  changeKonsul(id, reg, cm, unit_pengirim_id, unit_tujuan_id, dr_pengirim_id, dr_tujuan_id, diag, masalah, konsultasi) {
    return http.putData(`/surat-konsul/${id}`, {
      register_id: reg,
      pasien_rm: cm,
      unit_pengirim_id: unit_pengirim_id,
      unit_tujuan_id: unit_tujuan_id,
      dr_pengirim_id: dr_pengirim_id,
      dr_tujuan_id: dr_tujuan_id,
      diagnosis: diag,
      masalah: masalah,
      konsultasi: konsultasi
    })
  }

  saveJawabKonsul(surat_konsul_id, dr_konsulan_id, soap_id, note, reg, cm, unitId, s, o, a, p) {
    return http.postData(`/surat-konsul/${surat_konsul_id}/reply`, {
      surat_konsul_id: surat_konsul_id,
      dr_konsulan_id: dr_konsulan_id,
      soap_id: soap_id,
      note: note,
      register_id: reg,
      pasien_cm: cm,
      unit_id: unitId,
      subjective: s,
      objective: o,
      assesment: a,
      plan: p
    })
  }

  changeJawabKonsul(surat_konsul_id, dr_konsulan_id, soap_id, note, reg, cm, unitId, s, o, a, p) {
    return http.putData(`/surat-konsul/${surat_konsul_id}/reply`, {
      surat_konsul_id: surat_konsul_id,
      dr_konsulan_id: dr_konsulan_id,
      soap_id: soap_id,
      note: note,
      register_id: reg,
      pasien_cm: cm,
      unit_id: unitId,
      subjective: s,
      objective: o,
      assesment: a,
      plan: p
    })
  }

  batalKonsul(id, alasan) {
    return http.putData(`/surat-konsul/${id}/batal`, {
      alasan: alasan
    })
  }

  // changeKonsul(id, unit_tujuan_id, diag, masalah, konsultasi) {
  //   return http.put(`/surat-konsul/${id}`, {
  //     unit_tujuan_id: unit_tujuan_id,
  //     diagnosis: diag,
  //     masalah: masalah,
  //     konsultasi: konsultasi
  //   })
  // }
  // saveTtdKonsul(reg, user_id, password) {
  //   return http.post(`/register/${reg}/resume-ralan-paket/signature`, {
  //     dpjp_id: user_id,
  //     password: password

  //   })
  // }

}

export default new InterfaceKonsul();
